import {
    type PropsWithChildren,
    useLayoutEffect,
    useMemo,
    useState,
} from 'react';

import { THEME_LOCALSTORAGE_KEY } from '@/shared/constants/localstorage';
import { THEME, type Theme } from '@/shared/constants/theme';
import { ThemeContext } from '@/shared/lib/contexts';

interface ThemeProviderProps extends PropsWithChildren {
    initialTheme?: Theme;
}

export function ThemeProvider(props: ThemeProviderProps) {
    const { children, initialTheme } = props;

    const fallbackTheme = localStorage.getItem(THEME_LOCALSTORAGE_KEY) as Theme;

    const [theme, setTheme] = useState<Theme>(
        initialTheme || fallbackTheme || THEME.dark,
    );

    const defaultProps = useMemo(() => ({ theme, setTheme }), [theme]);

    useLayoutEffect(() => {
        localStorage.setItem(THEME_LOCALSTORAGE_KEY, theme);

        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={defaultProps}>
            {children}
        </ThemeContext.Provider>
    );
}
